import * as Yup from "yup";

export const ValidationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required."),
  sourcePortfolio: Yup.string(),
});
